import { JobStatuses } from '../../../../types/api/print-job'
import Shipment from '../../../../types/api/shipment'

export type PrintProgress = 'waiting' | 'printing' | 'printed'

export function getPrintProgress(shipment?: Shipment): PrintProgress {
    switch (shipment?.print_job?.jobStatus) {
        case JobStatuses.Printing:
            return 'printing'
        case JobStatuses.Completed:
            return 'printed'
        default:
            return 'waiting'
    }
}
